import Image from "next/image"
import Loading from "@/components/checkout/checkoutOrder/spinningLoader/images/loading.svg";

export const LoadingIndicator = () => {
  return (
    <div
      className="w-full h-fit flex items-center justify-center"
      title="Loading"
    >
      <Image src={Loading} alt="loading" />
    </div>
  );
};
